import {Box} from '@mui/material';
import {useCallback, useEffect, useRef} from 'react';
import SearchBar from '@/components/ui/search-bar';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {updateFilter} from '@/redux-store/slices/filter';
import {FilterDocumentType} from '@/types/filter';
import {useAppSelector} from '@/redux-store/store';

interface TextSearchProps {
  searchLabel: string;
  searchType: FilterDocumentType;
  onApply: () => void;
}

const TextSearch: React.FC<TextSearchProps> = ({
  searchLabel,
  searchType,
  onApply
}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const filter = useAppSelector((state) => state.filter);

  const prevTextSearchRef = useRef<string | null | undefined>(undefined);

  const handleSearchChange = useCallback(
    (textToSearch: string) => {
      dispatch(
        updateFilter({type: searchType, data: {textSearch: textToSearch}})
      );
    },
    [dispatch, searchType]
  );

  useEffect(() => {
    const currentFilter = filter[searchType];
    const currentTextSearch = currentFilter.textSearch;

    if (prevTextSearchRef.current !== currentTextSearch) {
      prevTextSearchRef.current = currentTextSearch;
      onApply();
    }
  }, [filter, onApply, searchType]);

  return (
    <Box
      sx={{
        width: '100%'
      }}
    >
      <SearchBar
        searchText={filter[searchType].textSearch}
        onSearch={handleSearchChange}
        placeholder={t(searchLabel)}
        isInFilter
        maxWidth
      />
    </Box>
  );
};

export default TextSearch;
